import { getTokenLocalStorage } from '../../../localStorage.util';
import store from '../../../configureStore.util';
import * as commonActions from '../common.action';
import { apiUrl } from '../../../constants/defaultValues';
import { getCurrentLanguage } from '../../../helpers';
export const listaEquivalenciaPesquisa = [
	{ label: 'Médico executante', query: 'medicoExecutante' },
	{ label: 'Exames', query: 'exames' },
	{ label: 'Laudo', query: 'laudo' },
	{ label: 'Laudos', query: 'listaLaudos' },
	{ label: 'Tipo exame', query: 'tipoExame' },
	{ label: 'Encaminhamento', query: 'encaminhamento' },
	{ label: 'Diagnóstico', query: 'diagnostico' },
	{ label: 'Não conformidade', query: 'naoConformidade' },
	{ label: 'Setor solicitante', query: 'setorSolicitante' },
	{ label: 'Número exame', query: 'numeroExame' },
	{ label: 'Número pedido', query: 'numeroPedido' },
	{ label: 'Cartão nacional SUS', query: 'cartaoSUS' },
	{ label: 'Accession number', query: 'accessionNumber' },
	{ label: 'Paciente', query: 'paciente' },
	{ label: 'Atendimento', query: 'atendimento' },
	{ label: 'Prontuário', query: 'prontuario' },
	{ label: 'Matrícula SAME', query: 'matriculaSame' },
	{ label: 'Convênio', query: 'convenio' },
	{ label: 'Grupo exame', query: 'grupoExame' },
	{ label: 'Médico solicitante', query: 'medicoSolicitante' },
	{ label: 'Médico revisor', query: 'medicoRevisor' },
	{ label: 'Procedimento', query: 'procedimento' },
	{ label: 'Unidade atendimento', query: 'unidadeAtendimento' },
	{ label: 'dataInicial', query: 'periodo-de' },
	{ label: 'dataFinal', query: 'periodo-ate' },
	{ label: 'Etapa', query: 'etapa' },
	{ label: 'Recebimento Material', query: 'status-recebimento' },
	{ label: 'Congelação', query: 'status-congelacao' },
	{ label: 'Macroscopia', query: 'status-macro' },
	{ label: 'Microscopia', query: 'status-micro' },
	{ label: 'Imuno', query: 'status-imuno' },
	{ label: 'Fish', query: 'status-fish' },
	{ label: 'Cish', query: 'status-cish' },
	{ label: 'Histo', query: 'status-histo' },
	{ label: 'PCR', query: 'status-pcr' },
	{ label: 'Notas', query: 'status-notas' },
	{ label: 'Errata', query: 'status-errata' },
	{ label: 'Conclusão', query: 'status-conclusao' },
	{ label: 'Impresso', query: 'status-impresso' },
	{ label: 'Data de entrega de', query: 'dataEntregaDe' },
	{ label: 'Data de entrega até', query: 'dataEntregaAte' },
	{ label: 'Data de solicitação de', query: 'dataSolicitacaoDe' },
	{ label: 'Data de solicitação até', query: 'dataSolicitacaoAte' },
	{ label: 'Data não conformidade de', query: 'dataInconformidadeDe' },
	{ label: 'Data não conformidade até', query: 'dataInconformidadeAte' },
	{ label: 'Resolução não conformidades', query: 'resolucaoInconformidade' },
	{ label: 'Tipo não conformidade', query: 'tipoInconformidade' },
	{ label: 'Ativo', query: 'ativo' },
	{ label: 'Urgente', query: 'urgente' },
	{ label: 'Topografia', query: 'topografia' },
	{ label: 'Data de liberação de', query: 'dataLiberacaoDe' },
	{ label: 'Data de liberação até', query: 'dataLiberacaoAte' },
	{ label: 'Status da etapa', query: 'statusEtapa' },
	{ label: 'Nº Exame Externo', query: 'exameExterno' },
	{ label: 'Observação do Laudo', query: 'observacao' },
	{ label: 'CPF', query: 'cpf' },
	{ label: 'Data de nascimento', query: 'dataNascimento' }
];

// Função anterior

// const replaceFiltrosQueryString = (param) => {
// 	return listaEquivalenciaPesquisa.filter((obj) => {
// 		return obj.label === param;
// 	})[0].query;
// };

// Função ajustada de acordo com a tarefa: https://jira.mv.com.br/browse/ANATOWEB-3964

const replaceFiltrosQueryString = (param) => {
	const filtroEncontrado = listaEquivalenciaPesquisa.find((obj) => {
		return obj.label === param;
	});

	if (filtroEncontrado) {
		return filtroEncontrado.query;
	} else {
		return 'numeroPedido';
	}
};

export const getPayload = (obj) => {
	let payload = {};
	let filtroEncontrado = {};

	obj.forEach((element) => {
		filtroEncontrado = listaEquivalenciaPesquisa.find((x) => {
			return x.label === element.param;
		});

		if (filtroEncontrado)
			payload[`${filtroEncontrado.query}`] = element.value;
		else
			payload['numeroPedido'] = element.value;
	});

	return payload;
};

const querystringBuilder = (selecionados) => {
	let querystring = '';
	for (let i = 0; i < selecionados.length; i++) {
		const element = selecionados[i];
		const param = replaceFiltrosQueryString(element.param);
		querystring += `&${param}=${element.value}`;
	}
	return querystring;
};

const textLengthMessage = (text, tamanho, intl) => {
	let texto = String(text);

	let lengh = 0;

	if (!(text === undefined || text === 'undefined')) {
		lengh = texto.length;
	}

	const carac = tamanho - lengh;
	let msn = intl
		.formatMessage({ id: 'message.remaining.more' })
		.replace('{char}', carac);

	if (carac === 1) {
		msn = intl
			.formatMessage({ id: 'message.remaining.only' })
			.replace('{char}', carac);
	} else if (carac === 0) {
		msn = intl
			.formatMessage({ id: 'message.maxlength' })
			.replace('{char}', carac);
	}

	return msn;
};

const querystringBuilderByObject = (obj) => {
	let str =
		'?' +
		Object.keys(obj)
			.reduce(function (a, k) {
				a.push(k + '=' + encodeURIComponent(obj[k]));
				return a;
			}, [])
			.join('&');
	return str;
};

const buildUrlAPI = (pathname, version = 'v1') => {
	return `${apiUrl}api/${version}/${pathname}`;
};

const unionOptions = (a, b) => {
	var c = [];
	for (var i in a) {
		var shared = false;
		for (var j in b)
			if (b[j].value === a[i].value) {
				shared = true;
				break;
			}
		if (!shared) c.push(a[i]);
	}
	c = c.concat(b);
	return c;
};

const httpRequest = (url, metodo = 'GET', body = undefined, versao = 'v1') => {
	const token = getTokenLocalStorage();

	// if(!token){
	// 	localStorage.clear();
	// 	return window.location.replace(`/login`);
	// }

	let init = {
		method: metodo,
		headers: {
			Authorization: token,
			Accept: 'application/json',
			'Content-Type': 'application/json',
			'Accept-Language': getCurrentLanguage(),
		},
	};

	if (body !== undefined) {
		init = {
			...init,
			body: JSON.stringify(body),
		};
	}

	return fetch(buildUrlAPI(url, versao), init)
		.then((response) => {
			switch (response.status) {
				case 401:
					window.top.location = '/' + process.env.REACT_APP_LOGINPAGE;
					break;

				default:
					return response.url.indexOf('anexos/download') > -1
						? response
						: response.json();
			}
		})
		.then((json) => {
			if (json.success === undefined) return json;
			else if (json.success) return json;
			else {
				let message = json.message;

				if (json.data.length > 0) {
					message = Array.isArray(json.data) ? json.data[0] : json.data;
				}

				let width = message !== undefined ? message.length * 10 : 250;
				width = width < 250 ? 250 : width;

				store.dispatch(commonActions.showFadeCarregando(false));
				if (!message) {
					message = 'Erro ao salvar';
				}
				store.dispatch(
					commonActions.showAlerta('erro', message, 6000, width + 'px')
				);
				return Promise.reject(json);
			}
		})
		.catch((e) => {
			store.dispatch(commonActions.showFadeCarregando(false));
			return Promise.reject(e);
		});
};

const obterMesPorExtenso = (mes) => {
	switch (mes) {
		case 1:
			return 'JANEIRO';
		case 2:
			return 'FEVEREIRO';
		case 3:
			return 'MARÇO';
		case 4:
			return 'ABRIL';
		case 5:
			return 'MAIO';
		case 6:
			return 'JUNHO';
		case 7:
			return 'JULHO';
		case 8:
			return 'AGOSTO';
		case 9:
			return 'SETEMBRO';
		case 10:
			return 'OUTUBRO';
		case 11:
			return 'NOVEMBRO';
		case 12:
			return 'DEZEMBRO';
		default:
			return '';
	}
};

export {
	querystringBuilderByObject,
	querystringBuilder,
	httpRequest,
	obterMesPorExtenso,
	unionOptions,
	textLengthMessage,
};



// WEBPACK FOOTER //
// ./src/app/common/util/api-common.util.js